import MonthView from './MonthView';
import useOffcanvasStore from 'store/offcanvasStore';

const Header = ({ account, month, handleNewDate, setAnimation, hideCancelled, handleToggle, isPublicKhata = false }) => {
  const { openOffcanvas } = useOffcanvasStore();

  return (
    <div className="bg-app text-white py-2 d-flex">
      <div className="col-8 col-md-8 ps-3 d-flex align-items-center" align="left">
        {account?.get("photo") ? (
            <img 
              src={account.get("photo")}
              onClick={() => openOffcanvas('editAccount')}
              className="profile-img my-2 cursor-pointer"
              onError={(e) => {
                e.target.src = "https://placehold.co/150x150"; // Set the fallback image URL on error
              }} />
          ) : (
            <i className="bi bi-person-circle"
              onClick={() => openOffcanvas('editAccount')}
              style={{ fontSize: "45px" }} />
          )}

          <div className="mx-4 cursor-pointer" onClick={() => openOffcanvas('editAccount')}>
            <span className='fs-4 d-block'>{account ? account.get("name").substring(0, 30) : ""}</span>
            <span className="fw-normal d-block" style={{fontSize: "12px"}}><i>View Profile</i></span>
          </div>
      </div>
      <div className='col-1 col-md-1 mt-1 cursor-pointer' align="right">
        <i className={`fs-2 ${hideCancelled ? "bi-filter-circle-fill" : "bi-filter"}`} 
          onClick={() => handleToggle(!hideCancelled)}></i>
      </div>
      <div className="col-3 col-md-3 cursor-pointer pe-3" align="right">
        <MonthView
          selectedDate={month}
          handleNewDate={handleNewDate}
          setAnimation={setAnimation}
        />
      </div>
    </div>
  )
}

export default Header;